import { jsx as p } from "react/jsx-runtime";
import { c as u } from "../../index-Cu0xwYjD.js";
import { PanelCssClass as s, PanelBackground as f } from "./Panel.types.js";
import { GlobalCSSClass as B, PaddingSize as C, TextAlign as P } from "../../utils/enums.js";
import { getResponsivePaddingClasses as x } from "../../utils/helpers.responsive.js";
const a = ({
  children: e,
  background: o = "default",
  noBorderRadius: r,
  noGutter: t,
  padding: n = "md",
  stretch: i,
  textAlign: l = "inherit",
  className: d,
  ...m
}) => {
  const c = {
    [s.Stretch]: i,
    [s.NoBorderRadius]: r,
    [s.NoGutter]: t
  }, g = u(
    d,
    s.Base,
    `${B.TextAlignBase}--${l}`,
    `${s.Background}--${o}`,
    x(n),
    c
  );
  return /* @__PURE__ */ p("div", { className: g, ...m, children: e });
};
a.Background = f;
a.Padding = C;
a.TextAlign = P;
export {
  a as IressPanel
};
